<template>
  <button type="button">등록하기</button>
</template>

<script>
export default {
  name: 'BtnRegist',
  props: ['func']
}
</script>

<style scoped>
  button{
    width: 100%;
    z-index: 1;
    bottom: 0;
    font-size: 1.5em;
    color: #fff;
    background: #18698b;
    border: 1px solid #18698b;
    border-radius: 5px;
    padding:5px;
    cursor: pointer;
  }
  button:hover{
    background:#fff;
    color: #18698b;
  }
</style>
